import { axiosPrivate } from "api/axiosCore";

const basic_url = "api/wa-costs";

const request = async (token, method, url, data, params) => {
  try {
    return await axiosPrivate.request({ method, url, data, params, headers: { Authorization: `Bearer ${token}` } });
  } catch (error) {
    return error.response || { status: "No Server Response" };
  }
};

// filter: { startDate, endDate, groupBy, provider? }
export const serviceGetWaCostReport = (token, { startDate, endDate, groupBy, provider }) => {
  const params = { startDate, endDate, groupBy };
  if (provider) params.provider = provider;
  return request(token, "get", `${basic_url}/report`, undefined, params);
};

export const serviceGetWaCostRates = (token) => request(token, "get", `${basic_url}/rates`);

export const servicePostWaCostRate = (token, data) => request(token, "post", `${basic_url}/rates`, data);

export const servicePutWaCostRate = (token, id, data) => request(token, "put", `${basic_url}/rates/${id}`, data);

export const serviceDeleteWaCostRate = (token, id) => request(token, "delete", `${basic_url}/rates/${id}`);
